export const PaginationRow = {
  bindings: {
    onUpdateParam: '&',
    pagination: '<',
  },

  template: `
    <div class="pagination-row d-flex my-3"
      ng-if="$ctrl.pagination.previousPage || $ctrl.pagination.nextPage">
      <button class="btn btn-pill theme-btn text-white bg-cz-theme-secondary"
        ng-class="{ 'disabled': !$ctrl.pagination.previousPage }"
        ng-click="$ctrl.onUpdateParam({ key: 'page', value: $ctrl.pagination.previousPage })">
        Prev
      </button>
      <span class="text-center py-1 w-100">
        Page {{ $ctrl.pagination.page || 1 }} of {{ $ctrl.pagination.totalPages }}
      </span>
      <button class="btn btn-pill theme-btn text-white bg-cz-theme-secondary"
        ng-class="{ 'disabled': !$ctrl.pagination.nextPage }"
        ng-click="$ctrl.onUpdateParam({ key: 'page', value: $ctrl.pagination.nextPage })">
        Next
      </button>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Pagination/PaginationRow.js